import { ReactNode } from 'react';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import CountrySelect from './CountryFilter';
import StoreFilter from './StoreFilter';
import BusinessDateFilter from './BusinessDateFilter';
import ReprocessTypeFilter from './ReprocessTypeFilter';
import StatusFilter from './StatusFilter';
import { AppPermissions } from '../../../types';
import { PermissionsProvider } from '../../Permissions';
import { FilterPanel, StatusChip } from '../../Visual';

export interface ReprocessFiltersProps {
  actions: ReactNode;
  applyDisabled: boolean;
  countryRequiredIncomplete: boolean;
}

const ReprocessFilters = ({
  actions,
  applyDisabled,
  countryRequiredIncomplete,
}: ReprocessFiltersProps) => {
  const { t } = useTranslation();

  return (
    <PermissionsProvider resourcePermissions={[AppPermissions.REPROCESS]}>
      <FilterPanel
        subtitleTranslationKey="reprocess.filters.subtitle"
        actions={
          <StatusChip
            status={applyDisabled ? 'warning' : 'success'}
            label={applyDisabled ? t('filters.status.missingRequired') : t('filters.status.ready')}
          />
        }
      >
        <Grid container spacing={3} alignItems="flex-end">
          <Grid item xs={12} md={3} lg={2} xl={2}>
            <CountrySelect fullWidth requiredIncomplete={countryRequiredIncomplete} />
          </Grid>
          <Grid item xs={12} md={3} lg={2} xl={2}>
            <StoreFilter fullWidth />
          </Grid>
          {/* <GridBr /> */}
          <Grid item xs={12} md={3} lg={2} xl={2}>
            <BusinessDateFilter />
          </Grid>
          <Grid item xs={12} md={3} lg={2} xl={2}>
            <ReprocessTypeFilter fullWidth />
          </Grid>
          <Grid item xs={12} md={3} lg={2} xl={2}>
            <StatusFilter fullWidth />
          </Grid>
          <Grid item xs={12} md lg xl>
            {actions}
          </Grid>
        </Grid>
      </FilterPanel>
    </PermissionsProvider>
  );
};

export default ReprocessFilters;
